// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2LO7w","actions":"GroupTable_actions__3EhPF","deleteModalFooter":"GroupTable_deleteModalFooter__nnH8x"};